import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Nav() {
  const { pathname, hash } = useLocation();

  // A link is active only when both pathname and hash match its target.
  const linkCls = (to) => {
    const [targetPath, targetHash = ""] = to.split("#");
    const targetHashFull = targetHash ? `#${targetHash}` : "";
    const path = targetPath || "/";
    const isActive = pathname === path && (targetHashFull ? hash === targetHashFull : hash === "");
    return `text-xs uppercase tracking-[0.2em] font-mono transition-colors ${
      isActive ? "text-lime" : "text-white/70 hover:text-white"
    }`;
  };

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <span className="inline-block w-2.5 h-2.5 bg-lime animate-pulse-dot" />
          <span className="font-heading text-xl font-black tracking-tighter">
            PITCH<span className="text-lime">.</span>LU
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <Link data-testid="nav-episodes" to="/episodes" className={linkCls("/episodes")}>
            Episodes
          </Link>
          <Link data-testid="nav-how" to="/#how" className={linkCls("/#how")}>
            How it works
          </Link>
          <Link data-testid="nav-about" to="/#about" className={linkCls("/#about")}>
            About
          </Link>
          <Link data-testid="nav-sponsors" to="/#sponsors" className={linkCls("/#sponsors")}>
            Sponsors
          </Link>
        </nav>
        <Link
          to="/apply"
          data-testid="nav-apply-cta"
          className="px-5 py-2.5 bg-lime text-black font-heading font-bold text-sm uppercase tracking-wider hover:scale-[1.03] transition-transform"
        >
          Apply to Pitch →
        </Link>
      </div>
    </header>
  );
}
